export const updateTabIndexTore = ev => {
    return {
        type: 'UPDATETABINDEXTORE',
        ev: ev
    }
}

export const updateEditTore = ev => {
    return {
        type: 'UPDATEEDITTORE',
        ev: ev
    }
}

export const updateMusterTore = ev => {
    return {
        type: 'UPDATEMUSTERTORE',
        ev: ev
    }
}

export const updateModellKindTore = ev => {
    return {
        type: 'UPDATEMODELLKINDTORE',
        ev: ev
    }
}

export const updateModellTore = ev => {
    return {
        type: 'UPDATEMODELLTORE',
        ev: ev
    }
}

export const updateModellIndexTore = ev => {
    return {
        type: 'UPDATEMODELLINDEXTORE',
        ev: ev
    }
}

export const updateFormTore = ev => {
    return {
        type: 'UPDATEFORMTORE',
        ev: ev
    }
}

export const updateStepsTore = ev => {
    return {
        type: 'UPDATESTEPSTORE',
        ev: ev
    }
}

export const updateAllVisitedStepsTore = () => {
    return {
        type: 'UPDATEALLVISITEDSTEPSTORE'
    }
}

export const updadteHeightTore = ev => {
    return {
        type: 'UPDATEHEIGHTTORE',
        ev: ev
    }
}

export const updateWidthTore = ev => {
    return {
        type: 'UPDATEWIDTHTORE',
        ev: ev
    }
}

export const selectColorTore = ev => {
    return {
        type: 'SELECTCOLORTORE',
        ev: ev
    }
}

export const selectKindOfColorTore = ev => {
     return {
         type: 'SELECTKINDOFCOLORTORE',
         ev: ev
     }
}

export const selectWishColorTore = ev => {
    return {
        type: 'SELECTWISHCOLORTORE',
        ev: ev
    }
}


export const updateZaunspitzenTore = ev => {
    return {
        type: 'UPDATEZAUNSPITZENTORE',
        ev: ev
    }
}

export const updatePfostenTore = ev => {
    return {
        type: 'UPDATEPFOSTENTORE',
        ev: ev
    }
}

export const updateKappenTore = ev => {
    return {
        type: 'UPDATEKAPPENTORE',
        ev: ev
    }
}

export const updateAntrieb = ev => {
    return {
        type: 'UPDATEANTRIEB',
        ev: ev
    }
}

export const updateDirectionTore = ev => {
    return {
        type: 'UPDATEDIRECTIONTORE',
        ev: ev
    }
}

export const updateProductToMerklisteTore = ev => {
    return {
        type: 'UPDATEPRODUCTTOMERKLISTE',
        ev: ev
    }
}

export const updateDescriptionTore = ev => {
    return {
        type: 'UPDATEDESCRIPTIONTORE',
        ev: ev
    }
}
export const selectUploadDataTore = ev => {
    return {
        type: 'SELECTUPLOADDATATORE',
        ev: ev
    }
}


